import { gql } from "graphql.macro";

export const GET_SHOWROOM_URL = gql`
  query getGoogleApiKey {
    storeConfig {
        matterport_url
    }
  }
`;
